module.exports = __webpack_public_path__ + "static/media/jm.c5279e85.svg";